import { useEffect, useState } from 'react';
import {
	GetAppADGroups,
	GetAppCloudGroups,
	GetAppEUGroups,
	GetApplicationManagementByID,
} from '../../_api';
import { AD_TYPES } from 'pages/ApplicationMaintenance/_constants';
import Section from '../../components/NewApplication/Section';
import Spinner from '../../../../components/UI/Spinner/Spinner';
import ADGroupsDisplay from './components/ADGroupsDisplay';

const ADGroupManagement = ({
	appID,
	type = AD_TYPES.ON_PREM,
	currentUser,
	errors,
	requirementNumber,
	readOnly,
	setErrors,
	setKey = () => {},
}) => {
	const [sAppADGroups, setAppADGroups] = useState(null);
	const [sIsLoading, setIsLoading] = useState(true);
	const [sApp, setApp] = useState(null);

	useEffect(() => {
		const render = () => {
			setIsLoading(true);

			try {
				GetApplicationManagementByID(appID).then(resp => setApp(resp));

				switch (type) {
					case AD_TYPES.CLOUD:
						GetAppCloudGroups(appID)
							.then(response => setAppADGroups(response))
							.then(() => setIsLoading(false));
						break;
					case AD_TYPES.EU:
						GetAppEUGroups(appID)
							.then(response => setAppADGroups(response))
							.then(() => setIsLoading(false));
						break;
					case AD_TYPES.ON_PREM:
						GetAppADGroups(appID)
							.then(response => {
								setAppADGroups(response);
							})
							.then(() => setIsLoading(false));
						break;
					default:
						break;
				}
			} catch (ex) {}
		};

		render();
	}, [appID, type]);

	return (
		<>
			<Section
				label={`${
					type === AD_TYPES.CLOUD
						? 'Cloud'
						: type === AD_TYPES.EU
						? 'EU'
						: 'AD'
				} Group Mappings`}
			>
				{sIsLoading ? (
					<Spinner />
				) : (
					<ADGroupsDisplay
						adGroupxRefs={sAppADGroups}
						appID={appID}
						readOnly={readOnly}
						app={sApp}
						type={type}
						currentUser={currentUser}
						requirementNumber={requirementNumber}
						reload={setKey}
						apiErrors={errors}
						setApiErrors={setErrors}
					/>
				)}
			</Section>
		</>
	);
};

export default ADGroupManagement;
